/* eslint-disable no-unused-vars */
import Splide from "@splidejs/splide";

// Init Splide if it has the 'carousel' class,
// else splide will not be initialised and the carousel
// will behave like a grid container.
const initSplide = () => {
  const elems = document.querySelectorAll(".splide-container.carousel .splide");

  elems.forEach((elem) => {
    const splide = new Splide(elem);

    splide.on("overflow", (isOverflow) => {
      if (!isOverflow) disableSplide(splide);
    });

    splide.mount();
  });
};

const disableSplide = (splide) => {
  const { options } = splide;
  options.drag = false;
  options.arrows = false;

  for (const [breakpoint, breakpointOptions] of Object.entries(
    options.breakpoints
  )) {
    breakpointOptions.arrows = false;
    breakpointOptions.drag = false;
  }
};

// Init Splide
document.addEventListener("DOMContentLoaded", initSplide);
